<template>
  <div class="modelgroup-guidance-container">
    <div
      class="step-box"
      v-if="currentStep === 1">
      <div
        class="step1-guide-bg"
        :class="
          $theme.get().value === 'dark'
            ? 'dark-step1-guide-bg'
            : 'light-step1-guide-bg'
        "></div>
      <div class="step-guide-box step1-guide-box step1">
        <p class="title">新手引导</p>
        <div class="content">
          <div>在<span class="height-color">【模型组管理】</span>分组下</div>
          <div>第一步，我们点击这里新建模型组。</div>
          <div class="height-color">
            注意哦，对于老用户，我们已经将数据迁移至默认模型组内，您可以直接查看下一步
          </div>
          <div class="common-button-box">
            <el-button
              type="primary"
              class="primary-btn"
              size="mini"
              @click="nextStep"
              >下一步</el-button
            >
          </div>
        </div>
      </div>
    </div>

    <div
      class="step-box"
      v-if="currentStep === 2">
      <div
        class="step2-guide-bg"
        :class="
          $theme.get().value === 'dark'
            ? 'dark-step2-guide-bg'
            : 'light-step2-guide-bg'
        "></div>
      <div class="step-guide-box2 step2">
        <p class="title">新手引导</p>
        <div class="content">
          <div>第二步，向创建好的模型组内上传模型</div>
          <div class="common-button-box">
            <el-button
              class="normal-btn"
              :class="$theme.get().value === 'dark' ? 'dark-btn' : ''"
              size="mini"
              @click="previousStep"
              >上一步</el-button
            >
            <el-button
              type="primary"
              size="mini"
              class="primary-btn"
              @click="nextStep"
              >下一步</el-button
            >
          </div>
        </div>
      </div>
    </div>

    <div
      class="step-box"
      v-if="currentStep === 3">
      <div
        class="step3-guide-bg"
        :class="
          $theme.get().value === 'dark'
            ? 'dark-step3-guide-bg'
            : 'light-step3-guide-bg'
        "></div>
      <div class="step-guide-box2 step3-guide-box step3">
        <p class="title">新手引导</p>
        <div class="content">
          <div>
            第三步，上传完成后，我们点击这里，可以看到模型组内部的子文件
          </div>
          <div class="common-button-box">
            <el-button
              class="normal-btn"
              :class="$theme.get().value === 'dark' ? 'dark-btn' : ''"
              size="mini"
              @click="previousStep"
              >上一步</el-button
            >
            <el-button
              type="primary"
              class="primary-btn"
              size="mini"
              @click="nextStep"
              >下一步</el-button
            >
          </div>
        </div>
      </div>
    </div>

    <div
      class="step-box"
      v-if="currentStep === 4">
      <div
        class="step4-guide-bg"
        :class="
          $theme.get().value === 'dark'
            ? 'dark-step4-guide-bg'
            : 'light-step4-guide-bg'
        "></div>
      <div class="step-guide-box2 step4">
        <p class="title">新手引导</p>
        <div class="content">
          <div>第四步，点击这里对这个模型组进行提交转换</div>
          <div class="common-button-box">
            <el-button
              class="normal-btn"
              :class="$theme.get().value === 'dark' ? 'dark-btn' : ''"
              size="mini"
              @click="previousStep"
              >上一步</el-button
            >
            <el-button
              type="primary"
              class="primary-btn"
              size="mini"
              @click="nextStep"
              >下一步</el-button
            >
          </div>
        </div>
      </div>
    </div>

    <div
      class="step-box"
      v-if="currentStep === 5">
      <div
        class="step5-guide-bg"
        :class="
          $theme.get().value === 'dark'
            ? 'dark-step5-guide-bg'
            : 'light-step5-guide-bg'
        "></div>
      <div class="step-guide-box step5">
        <p class="title">新手引导</p>
        <div class="content">
          <div>第五步，转换成功后，点击这里即可查看模型组</div>
          <div class="common-button-box">
            <el-button
              class="normal-btn"
              :class="$theme.get().value === 'dark' ? 'dark-btn' : ''"
              size="mini"
              @click="previousStep"
              >上一步</el-button
            >
            <el-button
              type="primary"
              class="primary-btn"
              size="mini"
              @click="start"
              >开始使用</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentStep: 1,
      steps: [1]
    }
  },
  props: {
    disableModelGroupGuidance: Function
  },
  methods: {
    previousStep() {
      this.currentStep--
    },
    nextStep() {
      this.currentStep++
      if (!this.steps.includes(this.currentStep)) {
        this.steps.push(this.currentStep)
      }
    },
    start() {
      this.disableModelGroupGuidance()
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.modelgroup-guidance-container {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  z-index: 10;

  .step-box {
    height: 100%;

    .light-step1-guide-bg {
      background: url('@/assets/user-guidance/modelgroup-step1.png') no-repeat;
    }

    .dark-step1-guide-bg {
      background: url('@/assets/user-guidance/dark-modelgroup-step1.png')
        no-repeat;
    }

    .step1-guide-bg {
      width: 100%;
      height: 100%;
      background-size: cover;
    }

    .dark-step2-guide-bg {
      background: url('@/assets/user-guidance/dark-modelgroup-step2.png')
        no-repeat;
    }

    .light-step2-guide-bg {
      background: url('@/assets/user-guidance/modelgroup-step2.png') no-repeat;
    }

    .step2-guide-bg {
      width: 100%;
      height: 100%;
      background-size: cover;
    }

    .dark-step3-guide-bg {
      background: url('@/assets/user-guidance/dark-modelgroup-step3.png')
        no-repeat;
    }

    .light-step3-guide-bg {
      background: url('@/assets/user-guidance/modelgroup-step3.png') no-repeat;
    }

    .step3-guide-bg {
      width: 100%;
      height: 100%;
      background-size: cover;
    }

    .dark-step4-guide-bg {
      background: url('@/assets/user-guidance/dark-modelgroup-step4.png')
        no-repeat;
    }

    .light-step4-guide-bg {
      background: url('@/assets/user-guidance/modelgroup-step4.png') no-repeat;
    }

    .step4-guide-bg {
      width: 100%;
      height: 100%;
      background-size: cover;
    }

    .dark-step5-guide-bg {
      background: url('@/assets/user-guidance/dark-modelgroup-step5.png')
        no-repeat;
    }

    .light-step5-guide-bg {
      background: url('@/assets/user-guidance/modelgroup-step5.png') no-repeat;
    }

    .step5-guide-bg {
      width: 100%;
      height: 100%;
      background-size: cover;
    }

    .step-guide-box {
      position: absolute;
      width: 360px;
      padding: 10px 20px;
      color: #222222;
      background: var(--guides-bgColor);
      text-align: left;
      border-radius: 5px;
      z-index: 3;

      &::after {
        position: absolute;
        display: block;
        border-color: transparent;
        border-style: solid;
        content: ' ';
        border-width: 6px;
        top: -5px;
        margin-left: 25px;
        border-top-width: 0;
        border-bottom-color: #ffffff;
      }
    }

    .step1-guide-box {
      &::after {
        right: -9px;
        top: 25px;
        transform: rotate(90deg);
      }
    }

    .step-guide-box2 {
      position: absolute;
      width: 360px;
      padding: 10px 20px;
      color: #222222;
      background: var(--guides-bgColor);
      text-align: left;
      border-radius: 5px;

      &::after {
        position: absolute;
        display: block;
        border-color: transparent;
        border-style: solid;
        content: ' ';
        border-width: 6px;
        top: -5px;
        margin-left: 300px;
        border-top-width: 0;
        border-bottom-color: #ffffff;
      }
    }

    .step3-guide-box {
      &::after {
        margin-left: 220px;
      }
    }

    .title {
      font-size: 18px;
      font-weight: bold;
    }

    .content {
      font-size: 14px;
      margin-top: 5px;
      line-height: 23px;
    }

    .height-color {
      color: var(--base-primary-bgColor);
    }

    .common-button-box {
      margin-top: 10px;
      text-align: right;

      .dark-btn {
        background: transparent;
        color: #777;
        border: 1px solid #777;
        &:hover {
          background: rgba(255, 255, 255, 0.15);
        }
      }
    }

    @media (max-width: 1920px) {
      .step1 {
        bottom: 82px;
        left: 674px;
      }
      .step2 {
        top: 310px;
        right: 225px;
      }
      .step3 {
        top: 310px;
        right: 60px;
      }
      .step4 {
        top: 310px;
        right: 88px;
      }
      .step5 {
        top: 310px;
        left: 620px;
      }
    }

    @media (min-width: 1921px) {
      .step1 {
        bottom: 270px;
        left: calc(50% + 200px);
      }

      .step2 {
        top: 385px;
        left: 775px;
      }

      .step3 {
        bottom: 335px;
        left: calc(50% + 270px);
      }

      .step4 {
        top: 300px;
        left: 970px;
      }

      .step5 {
        top: 300px;
        left: 830px;
      }
    }

    @media (min-height: 950px) {
      .step1 {
        bottom: 126px;
        left: 696px;
      }
    }

    @media (max-width: 1520px) {
      .step1 {
        bottom: 128px;
        left: 468px;
      }

      .step2 {
        top: 242px;
        right: 168px;
      }

      .step3 {
        top: 246px;
        right: 22px;
        width: 324px;
        &::after {
          margin-left: 182px;
        }
      }

      .step4 {
        top: 244px;
        right: 60px;
      }

      .step5 {
        top: 244px;
        left: 471px;
      }
    }
  }
}
</style>
